<template>
  <div class="simple-donut-chart">
    <apexchart
      type="donut"
      :height="160"
      :options="chartOptions"
      :series="chartSeries"
    />
    <slot name="legend" />
  </div>
</template>

<script>
export default {
  name: 'SimpleDonutChart',
  props: {
    sections: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    chartSeries() {
      return this.sections.map(section => section.value);
    },
    chartLabels() {
      return this.sections.map(section => section.label);
    },
    chartColors() {
      return this.sections.map(section => section.color);
    },
    chartOptions() {
      return {
        chart: {
          type: 'donut',
          height: 160,
          width: 160
        },
        labels: this.chartLabels,
        colors: this.chartColors,
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        plotOptions: {
          pie: {
            donut: {
              size: '50%'
            },
          }
        },
        stroke: {
          show: true,
          width: 3,
          curve: 'smooth',
          lineCap: 'round'
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + '%';
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.simple-donut-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>